declare namespace $ {

	export class $mol_icon_align_vertical_bottom extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=bottom.view.tree.d.ts.map